import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { usePopupManager } from 'react-popup-manager';
import { CustomAlarmDeletionConfirmationModalComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-deletion-confirmation-modal/custom-alarm-deletion-confirmation-modal.component';
import { useCustomAlarmsDeleter } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-deleter/use-custom-alarms-deleter.hook';
import { useCustomAlarmsListContext } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-list-context/use-custom-alarms-list-context.hook';
import { CustomAlarmActiveConfirmationModalComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.component';
import { useCustomAlarmsActivation } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-activation/use-custom-alarms-activation.hook';

export const useCustomAlarmConfirmationModal = () => {
    const { deleteCustomAlarm } = useCustomAlarmsDeleter();
    const { setSelectedRows, fetchList } = useCustomAlarmsListContext();
    const { changeCustomAlarmsActiveStatus } = useCustomAlarmsActivation();
    const popupManager = usePopupManager();

    const resetView = () => {
        setSelectedRows([]);
        fetchList();
    };

    const showDeleteConfirmationModal = (alarms: CustomAlarmListItem[]) => {
        popupManager.open(CustomAlarmDeletionConfirmationModalComponent, {
            onConfirm: () => deleteCustomAlarm(alarms).then(resetView),
            alarmDefinitions: alarms,
        });
    };

    const showActivateConfirmationModal = (customAlarms: CustomAlarmListItem[]) => {
        popupManager.open(CustomAlarmActiveConfirmationModalComponent, {
            customAlarms,
            action: 'activate',
            onConfirm: () => changeCustomAlarmsActiveStatus(customAlarms, true).then(resetView),
        });
    };

    const showDeactivateConfirmationModal = (customAlarms: CustomAlarmListItem[]) => {
        popupManager.open(CustomAlarmActiveConfirmationModalComponent, {
            customAlarms,
            action: 'deactivate',
            onConfirm: () => changeCustomAlarmsActiveStatus(customAlarms, false).then(resetView),
        });
    };

    return {
        showDeleteConfirmationModal,
        showActivateConfirmationModal,
        showDeactivateConfirmationModal,
    };
};
